<template>
  <v-row>
    <v-col cols="12" class="pt-0">
      <Title
        text-start
        :font-weight="600"
        :font-size="14"
        title="Документ о достижении"
        append-icon="mdi-trash-can-outline"
        @click:append-outer="removeAchievement"
      />
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-text-field
        v-model="achievement.name"
        placeholder="Введите данные"
        rounded
        outlined
        dense
        @input="setAchievement"
      >
        <template #label>
          <span class="required">Наименование</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="6"  class="py-0">
      <v-text-field
        v-model="achievement.series"
        placeholder="Введите данные"
        rounded
        outlined
        dense
        @input="setAchievement"
      >
        <template #label>
          <span class="required">Серия</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="6"  class="py-0">
      <v-text-field
        v-model="achievement.number"
        placeholder="Введите данные"
        rounded
        outlined
        dense
        @input="setAchievement"
      >
        <template #label>
          <span class="required">Номер</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="6"  class="py-0">
      <DatePicker
        label="Дата выдачи"
        required
        :prop-date="achievement.issueDate"
        @set-date="setIssueDate"
      />
    </v-col>

    <v-col cols="12" class="py-0">
      <v-text-field
        v-model="achievement.issueBy"
        placeholder="Введите данные"
        rounded
        outlined
        dense
        @input="setAchievement"
      >
        <template #label>
          <span class="required">Кем выдан</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" class="pt-0">
      <FileInput
        title="Файл документа о достижении"
        :ref-id="achievement.id"
        ref-class-name="Achievement"
        @set-files="setFiles"
      />
    </v-col>
  </v-row>
</template>

<script>
import Title from '@/components/ui/Title'
import DatePicker from '@/components/ui/DatePicker'
import FileInput from '@/components/ui/FileInput'
import {Achievement} from "@/models"

export default {
  name: "Achievement",

  components: {
    Title,
    DatePicker,
    FileInput
  },

  props: {
    item: Achievement,
    index: Number
  },

  data: () => ({
    achievement: new Achievement()
  }),

  computed: {},

  methods: {
    setAchievement() {
      this.$emit('set-data', this.achievement)
    },

    removeAchievement() {
      this.$emit('remove', this.achievement)
    },

    setIssueDate(value) {
      this.achievement.issueDate = value
      this.setAchievement()
    },

    setFiles(value) {
      this.achievement.filesData = value
      this.setAchievement()
    }
  },

  watch: {
    'item': {
      deep: true,
      immediate: true,
      handler() {
        this.achievement = Achievement.build(this.item)
      }
    }
  }
}
</script>

<style scoped>
</style>
